import { Box } from '@chakra-ui/react';
import React from 'react';

interface ListItemActionProps {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}
export const ListItemAction: React.FC<ListItemActionProps> = ({
  className,
  onClick,
  children,
}) => (
  <Box
    className={className}
    onClick={(e) => {
      if (onClick) {
        onClick();
      }
      e.stopPropagation();
      e.preventDefault();
    }}
  >
    {children}
  </Box>
);
